import React from "react";
import {
	MagnifyingGlassIcon
  } from '@heroicons/react/24/outline'

export default function SearchButton({setOpen}) {

	return (
		<button
			type="button"
			className="inline-flex items-center justify-center w-7 h-7 text-white lg:bg-orange-700 rounded-full shadow-sm mr-7"
			onClick={() => setOpen(true)}
		>
			<span className="sr-only">Search</span>
			<MagnifyingGlassIcon className='w-4 stroke-[3px]'/>
		</button>
	)
}